import React from "react";
import JisButton from "../controls/jisButton";
import * as Constants from "../../constants";

const NjcReportFilters = ({
  search,
  onSearchChange,
  onSearch,
  frequentData,
  courts,
  quarters,
  reportTypes,
  showJudges = false,
}) => {
  return (
    <div className="panel">
      <div className="title">NCJ Report</div>
      <div className="panel-body">
        <div style={{ display: "flex" }}>
          <div className="select-group">
            <label>Report Type *</label>
            <select
              name="reportType"
              value={search.reportType}
              onChange={onSearchChange}
              required
            >
              <option value="">Select</option>
              {reportTypes.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <div className="select-group">
            <label>Schedule Type</label>
            <select
              name="eventtype"
              value={search.eventtype}
              onChange={onSearchChange}
              required
            >
              <option value="all">All</option>
              <option value="cmc">CMC</option>
              <option value="trial">Trial</option>
            </select>
          </div>
        </div>

        <div style={{ display: "flex" }}>
          <div className="select-group">
            <label>Division</label>
            <select
              name="divisionid"
              value={search.divisionid}
              onChange={onSearchChange}
              required
            >
              <option value="">Select</option>
              {frequentData.divisions?.map((opt) => (
                <option key={opt.id} value={opt.id}>
                  {opt.title}
                </option>
              ))}
            </select>
          </div>
          <div className="select-group">
            <label>Year</label>
            <select
              name="year"
              value={search.year}
              onChange={onSearchChange}
              required
            >
              <option value="">Select</option>
              {Array.from(
                { length: new Date().getFullYear() - 2013 + 1 },
                (_, i) => {
                  const year = new Date().getFullYear() - i;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                }
              )}
            </select>
          </div>
        </div>

        <div style={{ display: "flex" }}>
          {showJudges && (
            <div className="select-group">
              <label>Judges</label>
              <select
                name="judgeid"
                value={search.judgeid}
                onChange={onSearchChange}
              >
                <option value="">Select</option>
                {courts.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {Constants.judgeName(opt)}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="select-group">
            <label>Quarter</label>
            <select
              name="lastdate"
              value={search.lastdate}
              onChange={onSearchChange}
              required
            >
              <option value="">Select</option>
              {quarters.map((opt, ind) => (
                <option key={ind} value={opt.value}>
                  {opt.text}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="panel-btn">
        <JisButton onClick={() => onSearch(search)}>Generate Report</JisButton>
      </div>
    </div>
  );
};

export default NjcReportFilters;
